document.addEventListener("DOMContentLoaded", () => {
	document.addEventListener("wpcf7mailsent", () => {
		const popup = document.getElementById("success-send");

		if (popup) {
			popup.classList.add("popup-active");
			document.body.classList.add("no-scroll");
		}
	});
});
